export default __webpack_public_path__ + "static/media/stc-sample.a8fe7a22.svg";